import React, { memo } from "react";
import { useT } from "@al/next/al-ex";

import Iconfont from "~/components/ui/Iconfont";
import NavBar from "~/components/ui/NavBar";

import styles from "./styles.scss";

const NoProduct: React.FC = () => {
  const t = useT();
  return (
    <div className={styles.page}>
      <NavBar className={styles.nav_bar} />
      <div className={styles.main}>
        <Iconfont className={styles.icon} colorful name="no-product" />
        <div className={styles.tips}>{t("商品不存在")}</div>
      </div>
    </div>
  );
};

export default memo(NoProduct);
